import i18n from 'i18n';

export const mainColumnHeaders = {
  internalActivity: i18n.t('internalActivity', { ns: 'mapping' }),
  counterparty: i18n.t('counterparty', { ns: 'mapping' }),
  externalActivity: i18n.t('externalActivity', { ns: 'mapping' }),
};

export const buttons = {
  addInternalActivity: i18n.t('addInternalActivity', { ns: 'mapping' }),
  addExternalActivity: i18n.t('addExternalActivity', { ns: 'mapping' }),
  save: i18n.t('button.save', { ns: 'misc' }),
  cancel: i18n.t('button.cancel', { ns: 'misc' }),
  create: i18n.t('button.create', { ns: 'misc' }),
  delete: i18n.t('button.delete', { ns: 'misc' }),
};

export const addExternalActivityError = i18n.t('addExternalActivityError', {
  ns: 'mapping',
});
export const addExternalActivitySuccess = i18n.t('addExternalActivitySuccess', {
  ns: 'mapping',
});
export const deleteExternalActivitySuccess = i18n.t(
  'deleteExternalActivitySuccess',
  { ns: 'mapping' },
);
export const deleteExternalActivityError = i18n.t(
  'deleteExternalActivityError',
  { ns: 'mapping' },
);

export const updateExternalActivitySuccess = i18n.t(
  'updateExternalActivitySuccess',
  { ns: 'mapping' },
);
export const updateExternalActivityError = i18n.t(
  'updateExternalActivityError',
  { ns: 'mapping' },
);

export const searchPlaceholder = i18n.t('search', { ns: 'mapping' });
export const allCounterparties = i18n.t('all', { ns: 'mapping' });

export const deleteExternalActivity = i18n.t('deleteExternalActivity', {
  ns: 'mapping',
});
export const confirmDeleteExternalActivity = i18n.t(
  'confirmDeleteExternalActivity',
  {
    ns: 'mapping',
  },
);

export const requiredLabel = i18n.t('required', { ns: 'validation' });
export const maxCodeLength = 500;
export const maxLengthLabel = i18n.t('maxLength', {
  ns: 'validation',
  0: maxCodeLength,
});

export const collapse = i18n.t('collapse', { ns: 'mapping' });

export const servicesPlural = {
  plural1: i18n.t('servicesPlural1', { ns: 'mapping' }),
  plural2: i18n.t('servicesPlural2', { ns: 'mapping' }),
  plural3: i18n.t('servicesPlural3', { ns: 'mapping' }),
};

export const counterpartiesPlural = {
  plural1: i18n.t('counterpartiesPlural1', { ns: 'mapping' }),
  plural2: i18n.t('counterpartiesPlural2', { ns: 'mapping' }),
  plural3: i18n.t('counterpartiesPlural3', { ns: 'mapping' }),
};

export const notSpecified = i18n.t('notSpecified', { ns: 'mapping' });
